/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramAuthControllerRefreshTokenMutationRequest,
  TelegramAuthControllerRefreshTokenMutationResponse,
  TelegramAuthControllerRefreshToken401,
  TelegramAuthControllerRefreshToken403,
} from '../types/TelegramAuthControllerRefreshToken.ts';

function getTelegramAuthRefreshTokenUrl() {
  const res = { method: 'POST', url: `/api/telegram/auth/refresh` as const };
  return res;
}

/**
 * {@link /api/telegram/auth/refresh}
 */
export async function telegramAuthRefreshToken(
  data: TelegramAuthControllerRefreshTokenMutationRequest,
  config: Partial<RequestConfig<TelegramAuthControllerRefreshTokenMutationRequest>> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramAuthControllerRefreshTokenMutationResponse,
    ResponseErrorConfig<TelegramAuthControllerRefreshToken401 | TelegramAuthControllerRefreshToken403>,
    TelegramAuthControllerRefreshTokenMutationRequest
  >({ method: 'POST', url: getTelegramAuthRefreshTokenUrl().url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
